import { Activity, ActivityType } from '../types';
import { getVietnamDateString } from '../utils/formatters';

export interface Badge {
  id: string;
  name: string;
  description: string;
  icon: string; // Path to image asset
  color: string;
}

export const BADGES: Badge[] = [
  {
    id: 'weekend_warrior',
    name: 'Không nghỉ',
    description: 'Hoạt động vào cả thứ 7 và Chủ nhật (trong cùng tuần)',
    icon: '/badges/weekend_warrior.png',
    color: 'bg-purple-100 text-purple-700',
  },
  {
    id: 'marathoner',
    name: 'Chân dẻo',
    description: 'Chạy một lần trên 21km',
    icon: '/badges/marathoner.png',
    color: 'bg-green-100 text-green-700',
  },
  {
    id: 'iron_legs',
    name: 'Xé gió',
    description: 'Đạp xe một lần trên 50km',
    icon: '/badges/iron_legs.png',
    color: 'bg-orange-100 text-orange-700',
  },
  {
    id: 'fish',
    name: 'Kình ngư',
    description: 'Bơi một lần trên 3km',
    icon: '/badges/fish.png',
    color: 'bg-blue-100 text-blue-700',
  },
  {
    id: 'triathlete',
    name: 'Người sắt',
    description: 'Đã tham gia cả 3 môn: Bơi, Đạp, Chạy',
    icon: '/badges/triathlete.png',
    color: 'bg-yellow-100 text-yellow-700',
  },
  {
    id: 'early_bird',
    name: 'Gà Trống',
    description: 'Hoạt động trước 6:00 sáng',
    icon: '/badges/early_bird.png',
    color: 'bg-sky-100 text-sky-700',
  },
  {
    id: 'night_owl',
    name: 'Cú Đêm',
    description: 'Hoạt động sau 21:00 tối',
    icon: '/badges/night_owl.png',
    color: 'bg-indigo-100 text-indigo-700',
  },
  {
    id: 'endurance_master',
    name: 'Siêu bền',
    description: 'Hoạt động kéo dài trên 2 tiếng',
    icon: '/badges/endurance_master.png',
    color: 'bg-red-100 text-red-700',
  }
];

export const calculateStreak = (activities: Activity[]): number => {
  if (activities.length === 0) return 0;

  // 1. Convert all activity dates to Vietnam Date Strings (YYYY-MM-DD)
  // This ensures we group activities by their "Vietnam Day" regardless of the timestamp
  const uniqueDates = Array.from(new Set(activities.map(a => getVietnamDateString(a.date))))
    .sort((a, b) => new Date(b).getTime() - new Date(a).getTime());

  if (uniqueDates.length === 0) return 0;

  // 2. Get "Today" in Vietnam Time
  const today = getVietnamDateString(new Date());

  // 3. Get "Yesterday" in Vietnam Time
  // Safe way: subtract 24h from now, then get VN string.
  const todayDate = new Date(today); // UTC midnight of today string
  const yesterdayDate = new Date(todayDate);
  yesterdayDate.setDate(todayDate.getDate() - 1);
  const yesterday = yesterdayDate.toISOString().split('T')[0];

  // Check if the most recent activity was today or yesterday to start the streak
  const lastActivityDate = uniqueDates[0];
  if (lastActivityDate !== today && lastActivityDate !== yesterday) {
    return 0; // Streak broken if last activity was before yesterday
  }

  let streak = 0;

  // Count backwards
  // Start checking from the last activity date found
  let expectedDate = new Date(lastActivityDate);

  for (let i = 0; i < uniqueDates.length; i++) {
    const actualDateStr = uniqueDates[i];
    const expectedDateStr = expectedDate.toISOString().split('T')[0];

    // Check if this date matches the expected consecutive date
    if (actualDateStr === expectedDateStr) {
      streak++;
      // Move expected date back by one day
      expectedDate.setDate(expectedDate.getDate() - 1);
    } else {
      break;
    }
  }

  return streak;
};
